import { Service } from './baseService';

export const getFeatureTogglesService = () => Service.get(`/feature-toggles`);
